import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {



  getcrashCourselist ({ state, commit }) {
    axios.get('crash-course/get-course-list')
      .then(response => {
        state.courseList = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getCourseSubjectList ({ state, commit }, id) {
    axios.get('crash-course/get-subject-list-by-course/' + id)
      .then(response => {        
        state.courseSubjectList = response.data
      }).catch((err) => {
      })
  },
  

  getCourseSubjectDetails ({ state, commit }, subjectId) {

    axios.get('crash-course/get-subject-materials-list/'+ subjectId)
      .then(response => {
        state.courseSubjectDetail = response.data
        commit('setCourseSubjectDetail', response.data)
      }).catch((err) => {
      })

},


storeCrashCourseQuiz ( {dispatch}, obj) {
  return new Promise((resolve, reject) => {
    axios.post('crash-course/create-quiz', obj)
      .then(response => {
        resolve(response.data)
      //  dispatch('GetSpecialModelTestList')
      }).catch((err) => {
        reject(err)
      })
  })
},
storeScript ({ state }, obj) {
  return new Promise((resolve, reject) => {
    axios.post('crash-course/file/store-script', obj)
      .then(response => {
        resolve(response.data)
      }).catch((err) => {
        reject(err)
      })
  })
},
storeVideo ({ state }, obj) {
  return new Promise((resolve, reject) => {
    axios.post('crash-course/store-video', obj,
      {
        onUploadProgress: function (progressEvent) {
          state.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }.bind(this) })
      .then(response => {
        state.uploadPercentage = 0
        resolve(response.data)
      }).catch((err) => {
        reject(err)
      })
  })
},













  uploadDownloadUrls ({state}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('upload-video-downloadable-url', data)
        .then(response => {
          resolve(response.data)
      })
    })
  },
  storeLectureVideo ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('lecture/storeLectureVideo', obj,
        {
          onUploadProgress: function (progressEvent) {
            state.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
          }.bind(this) })
        .then(response => {
          state.uploadPercentage = 0
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  updateExamGeneric ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('exam/updateExamGeneric', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  storeQuestions ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('question/storeQuestions', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  storeQuestionsMultiple ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('question/storeQuestionsMultiple', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  updateQuestions ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('question/updateQuestions', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  addSubjectToCourse ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('course/addSubjectToCourse', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  // getcourselist ({ state, commit }) {
  //   axios.get('course/getcourselist')
  //     .then(response => {
  //       state.courseList = response.data
  //     // eslint-disable-next-line handle-callback-err
  //     }).catch((err) => {
  //     })
  // },
  getCourseDetails ({ state, commit }, id) {
    axios.get('crash-course/get-subject-list-by-course/' + id)
      .then(response => {
        state.courseDetail = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  // getCourseSubjectList ({ state, commit }, id) {
  //   axios.get('course/getSubjectsByCourseId/' + id)
  //     .then(response => {
  //       state.courseDetail = {},
  //       state.quiz_title = []
  //       state.courseSubjectList = response.data
  //       // state.quiz_title = state.courseDetail.name
  //       // state.courseSubjectList = response.data.subjects
  //       state.chapterList = []
  //       state.examList = []
  //       state.sheetList = []
  //       state.lecture_videoList = []
  //       state.examDetail = {}
  //     // eslint-disable-next-line handle-callback-err
  //     }).catch((err) => {
  //     })
  // },
  getLectureDetails ({ state, commit }, id) {
    axios.get('lecture/getLectureDetails/' + id)
      .then(response => {
        state.examList = response.data.exams

        state.lecture_videoDetails = response.data
        if (response.data.title) {
          state.sheetList = response.data.scripts
          state.quiz_title = state.courseDetail.name + ' | ' + state.subjectDetail.name + ' | ' + state.chapterDetail.name + ' | ' + response.data.title
        } else {
          state.quiz_title = state.courseDetail.name + ' | ' + state.subjectDetail.name + ' | ' + state.chapterDetail.name
          state.sheetList = state.chaperSheetList
        }
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getSubjectListNotInCourse ({ state, commit }, id) {
    axios.get('course/getSubjectListNotInCourse/' + id)
      .then(response => {
        state.subjectListNotInCourse = response.data
        commit('setSubjectListNotInCourse', response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getChapterNameListBySubjectId ({ state, commit }, obj, subjectId) {
    return new Promise((resolve, reject) => {
      axios.get('course/getChapterNameListBySubjectId/' + obj.courseId + '/' + obj.subjectId)
        .then(response => {
          state.subjectDetail = response.data.subject
          state.examList = response.data.exams
          if (state.subjectDetail) {
            state.quiz_title = state.courseDetail.name + ' | ' + state.subjectDetail.name
          } else {
            state.quiz_title = state.courseDetail.name
          }
          state.chapterList = response.data.chapters
          state.examDetail = {}
          resolve(response.data)
        // eslint-disable-next-line handle-callback-err
        }).catch((err) => {
        })
    })
  },
  storeChapter ({ state, commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('chapter/storeChapter', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  updateChapter ({ state, commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('chapter/updateChapter', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },

  getExamListByChapter ({ state, commit }, id) {
    axios.get('chapter/getExamListWithChapterDetailsByChapter/' + id)
      .then(response => {
        state.examList = response.data.exam_list
        state.lecture_videoList = response.data.lecture_videos
        state.sheetList = response.data.scripts
        state.chaperSheetList = response.data.scripts
        state.chapterDetail = response.data
        if (state.chapterDetail) {
          state.quiz_title = state.courseDetail.name + ' | ' + state.subjectDetail.name + ' | ' + state.chapterDetail.name
        } else {
          state.quiz_title = state.courseDetail.name + ' | ' + state.subjectDetail.name
        }
        state.examDetail = {}
        state.question.lecture_id = null
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getExamDetailById  ({ state }, obj) {
    let url = 'exam/getSubjectExamDetailById/'
    if (obj.chapter_id) {
      if (obj.lecture_id) {
        url = 'exam/getLectureExamDetailById/'
      } else {
        url = 'exam/getExamDetailById/'
      }
    }
    console.log(obj)
    axios.get(url + obj.quiz_id)
      .then(response => {
        state.examDetail = response.data
        console.log(response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  storeExamGeneric ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('exam/storeExamGeneric', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  goDetailPage ({ state }, obj) {
    console.log(obj)
    let param = obj.id + '/' + obj.subject_id + '/' + obj.chapter_id ? obj.chapter_id : 0 + '/' + obj.lecture_id ? obj.lecture_id : 0
    this.$router.push('/quiz-details/' + param)
  },
  storeLectureScript ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('file/storeLectureScript', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  storeChapterScript ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('file/storeChapterScript', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  setQuizDetails ({ state }, quiz) {
    return new Promise((resolve, reject) => {
      state.quizDetail = quiz
      resolve(true)
    })
  },
  getQuestions ({ state }) {
    axios.post('getQuestionsByPostMethod', state.quizDetail).then(response => {
      state.questionList = response.data
    })
  },
  deleteChapterScript ({ state }, id) {
    let obj = {
      'id': id
    }
    return new Promise((resolve, reject) => {
      axios.post('/file/deleteChapterScript', obj).then(response => {
        resolve(response.data)
      })
    })
  },
  deleteLectureScript ({ state }, id) {
    let obj = {
      'id': id
    }
    return new Promise((resolve, reject) => {
      axios.post('/file/deleteLectureScript', obj).then(response => {
        resolve(response.data)
      })
    })
  }
}
